import { Button } from "primereact/button";
import React from "react";
import "./ListSelect.scss";

interface ListItemProps {
  listItems: {
    id: string;
    name: string;
    isSelected?: boolean;
    description: string;
  }[];
  buttonLabel: string;
  handleFormData?: any;
}

export default function ListSelect({
  listItems,
  buttonLabel,
  handleFormData,
}: ListItemProps) {
  const handleButtonClick = (index: number) => {
    listItems[index].isSelected = !listItems[index].isSelected;
    handleFormData(
      listItems.filter((item) => item.isSelected).map((item) => item.name),
    );
  };
  return (
    <div className="list-dropdown">
      {listItems.map((item, i) => {
        return (
          <div className="list-dropdown-item" key={i}>
            <div className="list-dropdown-content">
              <h4>{item.name}</h4>
              <p>{item.description}</p>
            </div>
            <div className="list-dropdown-button">
              <Button
                label={`${item.isSelected ? "REMOVE" : "ADD"} ${buttonLabel}`}
                className={item.isSelected ? "" : "secondary"}
                onClick={() => handleButtonClick(i)}
                raised
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
